import { LoginForm } from "@/components/auth/login-form";
import { Divider, Text } from "@/components/ui";
import { MultivaLogo } from "./MultivaLogo";
import { UsuariosDemoCard } from "./UsuariosDemoCard";

/**
 * Panel derecho de /login · form de autenticación, divisor, card de
 * usuarios demo y footer de soporte. En mobile (sin panel marketing a la
 * izquierda) muestra también el logo como header para mantener el branding
 * visible.
 */
export function LoginFormPanel() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-8 md:h-full">
      <div className="multiva-fade-up flex w-full max-w-100 flex-col gap-6">
        <div className="md:hidden">
          <MultivaLogo variante="mobile" />
        </div>

        <div className="flex flex-col gap-1.5">
          <h2 className="text-[22px] font-bold leading-tight tracking-[-0.01em] text-foreground">Bienvenido de vuelta</h2>
          <Text c="dimmed" size="sm">
            Ingresa con tu cuenta corporativa para continuar.
          </Text>
        </div>

        <LoginForm />

        <Divider label={<span className="text-xs font-medium text-muted-foreground">Usuarios de demo</span>} />

        <UsuariosDemoCard />

        <Text size="xs" c="dimmed" ta="center">
          ¿Problemas para entrar?{" "}
          <a href="mailto:soporte@multiva.test" className="text-multiva-600 hover:underline">
            Contacta a soporte
          </a>
        </Text>
      </div>
    </div>
  );
}
